import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

/**
 * Custom Preloading Strategy
 * Precarga selectiva de módulos usando data: { preload: true }
 * Optimiza el rendimiento inicial cargando solo lo necesario
 */
@Injectable({
  providedIn: 'root'
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Si la ruta tiene data.preload = true, precarga después de 5 segundos
    if (route.data && route.data['preload']) {
      console.log('Preloading:', route.path);
      return timer(5000).pipe(
        mergeMap(() => load())
      );
    }
    
    // No precargar por defecto
    return of(null);
  }
}
